<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka瀏覽器外掛程式</h1>
                        <p>Trinka瀏覽器擴展程式可以即時糾正並提升您在喜歡的網站上的創作，安全地助您成地地寫作！</p>
                        <div id="safariBrowser">
                            <button title="即將推出 Safari">
                                <img src="../../../assets/images/safari_logo.png" alt="safari logo">
                                即將推出</button>
                            <div class="downloadForSafari">
                                <h2>下載:</h2>
                                <ul>
                                    <li>
                                        <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank" title="即將推出 Chrome">
                                            <img src="../../../assets/images/NewChromeFicon.svg" alt="chrome">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" title="即將推出 Firefox">
                                            <img src="../../../assets/images/NewFirefoxFicon.svg" alt="firefox">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" title="即將推出 Edge">
                                            <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Edge">
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div id="BrowserGoogleChromeSection">
                            <div class="browserPluginButton">
                                <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                    class="buttonGoogleChrome" id="BrowserChromeButton">
                                    <b>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome">
                                    </b>
                                    <i>安裝Chrome插件</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                        <img style="width: 32px;" src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox"> 安裝Firefox外掛
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                        <img style="width: 30px;" src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Edge"> 安裝Edge外掛
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div id="BrowserFirefoxSection">
                            <div class="browserPluginButton">
                                <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton">
                                    <b>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                    </b>
                                    <i>安裝Firefox插件</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                        <img style="width: 32px;" src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Firefox"> 另有適用版本
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                        <img style="width: 30px;" src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Edge"> 安裝Edge插件
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div id="BrowserEdgeBrowserSection">
                            <div class="browserPluginButton">

                                <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                    class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                    <b>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Edge">
                                    </b>
                                    <i>安裝Edge插件</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                        <img style="width: 32px;" src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Firefox"> 另有適用版本
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                        <img style="width: 30px;" src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Chrome"> 另有適用版本
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka瀏覽器
                            <br />外掛程式</h1>
                        <p>Trinka瀏覽器擴展程式可以即時糾正和增強您在喜歡的網站中的帖子和消息！ 助您一路安全成功地寫作！</p>

                    </div>
                </div> -->
                <!-- <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka瀏覽器
                            <br />外掛程式</h1>
                        <p>Trinka瀏覽器擴展程式可以即時糾正和增強您在喜歡的網站中的帖子和消息！ 助您一路安全成功地寫作！</p>

                    </div>
                </div> -->
                <!-- <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>Trinka瀏覽器<br />外掛程式</h1>
                        <p>Trinka瀏覽器擴展程式可以即時糾正和增強您在喜歡的網站中的帖子和消息！ 助您一路安全成功地寫作！</p>
                        <div class="browserPluginButton">
                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank" 
                            class="buttonGoogleChrome" id="BrowserChromeButton" >
                                <b>
                                    <img src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome">    
                                </b>
                                <i>安裝Chrome插件</i>
                            </a>
                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" 
                            class="buttonFireFox" id="BrowserFireFoxButton">
                                <b>
                                    <img src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                    </b>
                                    <i>安裝Firefox插件</i>
                            </a>
                        </div>
                        <br />
                        <div class="commingSoonSeciton">
                            <p class="FirefoxAvalibale">
                                <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                    <img style="width: 32px;" src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox"> 另有適用版本 
                                </a>
                            </p>
                            <p class="ChromeAvalibale">
                                <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                    <img style="width: 32px;" src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome"> 另有適用版本 
                                </a>
                            </p>
                            <p class="SafariComingSoon">
                                <img src="../../../assets/images/NewSafariIcon.svg" style="width: 32px;" alt="Grammar checker for Safari">即將推出
                            </p>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/BrowserPlugin_banner.png" alt="browser plugin">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 
    <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <h2><span></span>工作原理</h2>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="">
                                </div>
                                <h3>安裝瀏覽器擴展功能</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/RegisterAndLogin.png" alt="">
                                </div>
                                <h3>登錄/註冊</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="">
                                </div>
                                <h3>開始寫作</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="brandlogo_heading">
                        <h2>Trinka 的外掛程式適用於：</h2>
                    </div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/google-docs.png" alt="google doc">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/authorea.png" alt="authorea">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/researchgate.png" alt="research">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/medium.png" alt="medium">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/writing-cooprative.png" alt="writing">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/evernote.png" alt="evernote">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/notion.png" alt="notin">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/linked-in.png" alt="linkedin">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/twitter.png" alt="twitter">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/gmail.png" alt="gmail">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="viewfullList">
                        <!-- <a routerLink="/brand-list">View Full List</a> -->
                        還可用於更多不同平台
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>Trinka瀏覽器外掛程式的主要功能</h2>
                        <div class="HeadingSubLine"></div>
                        <p>為您喜愛的瀏覽器安裝Trinka外掛程式，幫助您隨時隨地寫得更好，以及即時獲取修訂和建議。更棒的是，它也會自動檢查所有更改，因此不會放過任何錯誤。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/realTimeEditing_icon.svg" alt="real time editing">
                        <h3>即時編輯</h3>
                        <p>Trinka會在您寫作時隨時修訂，無需等待編輯的修訂建議。</p>
                    </div>
                </div>
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards" data-aos="fade-up" data-aos-duration="1000">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="style guide icon">
                        <h3>風格指南設定</h3>
                        <p>根據常用的學術風格指南（AMA第11版，AGU 2017等等）調整手稿的文法和單詞選擇。</p>
                    </div>
                </div> -->
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards" data-aos="fade-left" data-aos-duration="1000">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area document">
                        <h3>專業領域和文件類型</h3>
                        <p>根據專業領域和文件類型定製Trinka，為您提供最相關的建議。</p>
                    </div>
                </div> -->
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AddtoDictionary.svg" alt="add to dictionary">
                        <h3>添加到詞典</h3>
                        <p>將自己的單詞添加到“我的詞典”中，這樣Trinka就不會在將來的寫作中將其標記為拼寫錯誤。</p>
                    </div>
                </div>
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards" data-aos="fade-up" data-aos-duration="1500">
                        <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="">
                        <h3>Word Count Reduction</h3>
                        <p>Trinka makes wordy phrases concise to make your writing impactful and comply with journal guidelines.</p>
                    </div>
                </div> -->
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DataSecurityIcon.svg" alt="data secure">
                        <h3>資料安全</h3>
                        <p>您輸入的任何內容都會被安全地傳輸和分析，我們決不會保留您的資料。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="writeToolboxs_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="writerBox_heading">
                        <h2>Trinka瀏覽器外掛程式：在哪工作都任您行</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">

                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>在Google Docs 上的文法更正</h2>
                            <p>您想在 Google Docs上更好地寫作，並輕鬆糾正所有文法錯誤嗎？</p>
                            <p>
                                添加 Trinka的瀏覽器擴展程式，並在 Google Docs上獲得即時文法和拼寫更正以及語言增強功能</p>
                            <!-- <a href="#">
                                Read More
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/google-doc-ss.jpg" alt="google doc" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections writeToolbox_inner_sections_even" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');background-position: right center;">
            <div class="container">
                <!-- <div class="row">
                            <div class="col-sm-12">
                                <div class="writerBox_heading">
                                    <h2><span></span>How to write better on Authorea?</h2>
                                </div>
                            </div>
                        </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/authorea-ss.jpg" alt="authorea" class="img-fluid">
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>如何在 Authorea上寫得更好？</h2>
                            <p>您是否使用Authorea來滿足您的寫作需求？如果是，那麼提高寫作品質的文法校正工具是必不可少的！</p>
                            <p>使用Trinka的瀏覽器外掛程式，即時修復文法錯誤，並在 Authorea 上寫得更好。</p>
                            <!-- <a href="#">
                                Read More
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <!-- <div class="row">
                                <div class="col-sm-12">
                                    <div class="writerBox_heading">
                                        <h2><span></span>Correct your writing on Evernote</h2>
                                    </div>
                                </div>
                            </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>修正你在 Evernote上的寫作</h2>
                            <p>提高你在Evernote上的寫作品質。Trinka是我們的人工智慧寫作工具，可以即時糾正文法並改進語言。</p>
                            <p>Trinka的瀏覽器擴展與Evernote完全相容，易於使用。您可以毫不費力地查看和編輯您的作品。</p>
                            <!-- <a href="#">
                                    Read More
                                    <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                                </a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/evernote-ss.jpg" alt="evernote" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections writeToolbox_inner_sections_even" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');background-position: right center;">
            <div class="container">
                <!-- <div class="row">
                                <div class="col-sm-12">
                                    <div class="writerBox_heading">
                                        <h2><span></span>Write better on Medium with Trinka</h2>
                                    </div>
                                </div>
                            </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/medium-ss.jpg" alt="medium" class="img-fluid">
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>提升在Medium上的寫作</h2>
                            <p>你在 Medium 上寫博客嗎？不要錯過 Trinka 免費瀏覽器外掛程式提供的編輯功能。</p>
                            <p>Trinka會在文法、語調、標點符號、句子結構等方面糾正您的寫作，並提高整體寫作品質，這將給Medium上的讀者留下深刻印象。</p>
                            <!-- <a href="#">
                                    Read More
                                    <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                                </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <div class="browser_plugin_cta">
        <div class="container">
            <div class="row">
                <div class="col-lg-12" id="BrowserGoogleChromeSection_cta">
                    <div class="trinka_cloud_banner_text">

                        <div class="browserPluginButton">
                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                class="buttonGoogleChrome" id="BrowserChromeButton">
                                <b>
                                    <img src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome">
                                </b>
                                <i>
                                    安裝Chrome插件</i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserFirefoxSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">
                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton_cta">
                                <b>
                                    <img src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                </b>
                                <i>安裝Firefox外掛 </i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserEdgeBrowserSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">

                            <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                <b>
                                    <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Edge">
                                </b>
                                <i>
                                    安裝Edge外掛</i>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他應用程式
                                    <br />中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/tw/trinkacloud">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Trinka Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/wordplugin">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word
                                                <br />外掛程式</h3>

                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise apps">
                                            <h3 style="margin: 0 0 -2px 0;">企業</h3>
                                            <span style="font-size: 10px; color: #000; position: relative;">(API, JS & On-Premise)</span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>